export const tailwindTextSize = [
  'text-base',
  'text-xs',
  'text-sm',
  'text-lg',
  'text-xl',
  'text-2xl',
  'text-3xl',
  'text-4xl',
  'text-5xl',
  'text-6xl',
  'text-7xl',
] as const;

export const tailwindTextLgSize = [
  'lg:text-xl',
  'lg:text-2xl',
  'lg:text-3xl',
  'lg:text-4xl',
  'lg:text-5xl',
  'lg:text-6xl',
  'lg:text-7xl',
  'lg:text-8xl',
] as const;

export const tailwindTextMdSize = [
  'md:text-xl',
  'md:text-2xl',
  'md:text-3xl',
  'md:text-4xl',
  'md:text-5xl',
  'md:text-6xl',
  'md:text-7xl',
  'md:text-8xl',
] as const;

export const tailwindTextAlign = ['text-center', 'text-right', 'text-left', 'text-justify'] as const;

export const tailwindTextWrap = ['break-words'] as const;

export const tailwindPadding = [
  'p-0',
  'p-1',
  'p-2',
  'p-3',
  'p-4',
  'md:p-4',
  'p-5',
  'p-6',
  'p-7',
  'p-8',
  'p-9',
  'p-10',
  'p-11',
  'p-12',
  'pt-2',
  'pt-5',
  'pb-0',
  'pb-1',
  'pb-2',
  'pb-4',
  'pb-72',
  'px-3',
  'px-8',
  'py-0',
  'py-2',
  'py-4',
  'py-7',
  'py-10',
  '*:p-1',
  '*:p-2',
  '*:p-2.5',
  '*:p-3',
] as const;

export const tailwindMargin = [
  'm-0',
  'mt-10',
  '-m-1',
  '-m-2',
  '-m-2.5',
  '-m-3',
  'm-auto',
  'mb-2',
  'mx-auto',
  'my-auto',
  'ml-auto',
  'mr-auto',
] as const;

export const tailwindWidth = ['w-full', 'w-auto', 'w-1/2', 'w-1/3', 'w-2/3', 'w-1/4', 'w-3/4'] as const;

export const tailwindMaxWidth = [
  'max-w-9',
  'max-w-10',
  'max-w-16',
  'max-w-20',
  'max-w-24',
  'max-w-28',
  'max-w-36',
  'max-w-40',
  'max-w-44',
  'max-w-48',
  'max-w-60',
  'max-w-72',
  'max-w-80',
  'max-w-96',
  'max-w-md',
  'max-w-lg',
  'max-w-xl',
  'max-w-2xl',
  'max-w-3xl',
  'max-w-4xl',
] as const;

export const tailwindHeight = [
  'h-full',
  'h-1',
  'h-2',
  'h-3',
  'h-4',
  'h-5',
  'h-6',
  'h-7',
  'h-8',
  'h-9',
  'h-10',
  'h-11',
  'h-12',
  'h-13',
  'h-14',
  'h-15',
  'h-16',
  'h-[384px]',
  'h-[448px]',
  'h-[512px]',
  'h-[768px]',
  'h-[896px]',
] as const;

export const tailwindMinHeight = ['min-h-48', 'min-h-52', 'min-h-60', 'min-h-64', 'min-h-72', 'min-h-80'] as const;
export const tailwindMaxHeight = [
  'max-h-48',
  'max-h-52',
  'max-h-60',
  'max-h-64',
  'max-h-72',
  'max-h-80',
  'max-h-96',
] as const;

export const tailwindRounded = [
  'rounded-none',
  'rounded-sm',
  'rounded',
  'rounded-md',
  'rounded-lg',
  'rounded-xl',
  'rounded-2xl',
  'rounded-full',
] as const;

export const tailwindBorderSize = ['border-0', 'border', 'border-2', 'border-4', 'border-8'] as const;

export const tailwindFontWeight = [
  'font-light',
  'font-medium',
  'font-semibold',
  'font-bold',
  'font-extrabold',
  'font-normal',
] as const;

export const tailwindFontStyle = ['italic', 'underline', 'line-through'] as const;

export const tailwindFlex = [
  'flex',
  'flex-row',
  'flex-col',
  'items-start',
  'items-end',
  'justify-start',
  'justify-end',
  'justify-center',
  'justify-around',
  'justify-between',
  'justify-self-start',
  'justify-self-end',
] as const;

export const tailwindBackgroundPosition = ['bg-top', 'bg-bottom', 'bg-center', 'bg-left', 'bg-right'] as const;

export const tailwindBackgroundOpacity = [
  'bg-opacity-0',
  'bg-opacity-10',
  'bg-opacity-25',
  'bg-opacity-50',
  'bg-opacity-75',
  'bg-opacity-100',
] as const;

export const tailwindGradientDirection = [
  'bg-gradient-to-t',
  'bg-gradient-to-b',
  'bg-gradient-to-r',
  'bg-gradient-to-l',
] as const;

export const tailwindBackgroundPattern = ['bg-pattern-1', 'bg-pattern-2'] as const;

export const tailwindBackdrop = [
  'backdrop-filter-none',
  'backdrop-filter',
  'backdrop-blur-sm',
  'backdrop-blur-lg',
  'backdrop-grayscale',
  'backdrop-sepia',
] as const;

export const tailwindShadowSize = [
  'shadow-none',
  'shadow-sm',
  'shadow',
  'shadow-md',
  'shadow-lg',
  'shadow-xl',
  'shadow-2xl',
] as const;

export const tailwindGap = [
  'gap-0',
  'gap-1',
  'gap-2',
  'gap-3',
  'gap-4',
  'gap-5',
  'gap-6',
  'gap-7',
  'gap-8',
  'gap-10',
] as const;

export const tailwindOrder = ['order-last', 'order-none', 'xl:order-none'] as const;

export type TailwindTextSize = (typeof tailwindTextSize)[number];
export type TailwindTextLgSize = (typeof tailwindTextLgSize)[number];
export type TailwindTextMdSize = (typeof tailwindTextMdSize)[number];
export type TailwindTextAlign = (typeof tailwindTextAlign)[number];
export type TailwindTextWrap = (typeof tailwindTextWrap)[number];
export type TailwindPadding = (typeof tailwindPadding)[number];
export type TailwindMargin = (typeof tailwindMargin)[number];
export type TailwindWidth = (typeof tailwindWidth)[number];
export type TailwindMaxWidth = (typeof tailwindMaxWidth)[number];
export type TailwindHeight = (typeof tailwindHeight)[number];
export type TailwindMinHeight = (typeof tailwindMinHeight)[number];
export type TailwindMaxHeight = (typeof tailwindMaxHeight)[number];
export type TailwindRounded = (typeof tailwindRounded)[number];
export type TailwindBorderSize = (typeof tailwindBorderSize)[number];
export type TailwindFontWeight = (typeof tailwindFontWeight)[number];
export type TailwindFontStyle = (typeof tailwindFontStyle)[number];
export type TailwindFlex = (typeof tailwindFlex)[number];
export type TailwindBackgroundPosition = (typeof tailwindBackgroundPosition)[number];
export type TailwindBackgroundOpacity = (typeof tailwindBackgroundOpacity)[number];
export type TailwindBackgroundPattern = (typeof tailwindBackgroundPattern)[number];
export type TailwindGradientDirection = (typeof tailwindGradientDirection)[number];
export type TailwindBackdrop = (typeof tailwindBackdrop)[number];
export type TailwindShadowSize = (typeof tailwindShadowSize)[number];
export type TailwindGap = (typeof tailwindGap)[number];
export type TailwindOrder = (typeof tailwindOrder)[number];

export type TailwindBorder = TailwindBorderSize;
export type TailwindShadow = TailwindShadowSize;

export type TailwindClassName =
  | TailwindTextSize
  | TailwindTextLgSize
  | TailwindTextMdSize
  | TailwindTextAlign
  | TailwindTextWrap
  | TailwindWidth
  | TailwindMaxWidth
  | TailwindHeight
  | TailwindMinHeight
  | TailwindMaxHeight
  | TailwindPadding
  | TailwindMargin
  | TailwindRounded
  | TailwindBorder
  | TailwindFlex
  | TailwindFontWeight
  | TailwindFontStyle
  | TailwindShadow
  | TailwindBackgroundPosition
  | TailwindBackgroundOpacity
  | TailwindBackgroundPattern
  | TailwindGradientDirection
  | TailwindBackdrop
  | TailwindGap
  | TailwindOrder;

export const hasTailwindClass = (compare: readonly TailwindClassName[], className: string[] | undefined): boolean => {
  if (className == null) {
    return false;
  }
  return className.some((item) => compare.includes(item as TailwindClassName));
};
